export const EVENTS = {
  ModelConnectivity: 'model-connectivity-ready',
  ModelRepaired: 'model-repaired-ready',
  ModelRepairCommit: 'model-repair-commit-ready',
  VersionDiff: 'diff-result-ready',
  MinimalModel: 'vis-result-ready',
  MinimalModelAtts: 'additional-element-atts-ready',
  VersionMerged: 'merge-result-ready',
  ModelError: 'model-general-error',
  ModelAdded: 'model-added',
  ModelCloned: 'model-cloned',
  DXFExport: 'model-dxf-export',
  ProgressUpdate:
    'progress-update' /* meant to be used for a progress bar - not yet implemented*/,
  routesAnalytics: 'routes-analytics'
};
